import { render, staticRenderFns } from "./OrderPartsList.vue?vue&type=template&id=12df61f3&scoped=true"
import script from "./OrderPartsList.vue?vue&type=script&lang=js"
export * from "./OrderPartsList.vue?vue&type=script&lang=js"
import style0 from "./OrderPartsList.vue?vue&type=style&index=0&id=12df61f3&prod&scoped=true&lang=scss"
import style1 from "./OrderPartsList.vue?vue&type=style&index=1&id=12df61f3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12df61f3",
  null
  
)

export default component.exports